<template>
  <v-container id="saneamento-voc-historico" tag="section" fluid>
    <v-row>
      <v-col cols="12">
        <saneamento-voc-data-table
          :calculos="calculos"
          :loading-items="loadingItems"
          @rechargeTable="getAllCalculos()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAllCalculos())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SaneamentoVocService from '@/services/SaneamentoVocService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      SaneamentoVocDataTable: () => import('@/components/saneamentoVoc/SaneamentoVocDataTable.vue')
    },
    mixins: [pusherMixins, tourMixins],

    data() {
      return {
        calculos: [],
        loadingItems: false,
        processamentosExpirados: false,
        arrTour: [
          {
            element: '#btn-novo-calculo',
            intro: 'Clicando neste botão você poderá criar novos Saneamentos do VOC.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#saneamento-voc-historico-search',
            intro: 'Neste campo você poderá pesquisar por Saneamentos do VOC já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-download-saneamento-voc',
            intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado do seu Saneamento do VOC.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-edit-saneamento-voc',
            intro: 'Clicando neste ícone você poderá editar seu Saneamento do VOC.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-saneamento-voc',
            intro:
              'Aqui você acessa outras opções para seu Saneamento do VOC, como ver mais detalhes, executá-lo novamente, duplicá-lo ou deletá-lo.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.subscribe();
      this.getAllCalculos();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshCalculoComCaAneel', () => {
          this.getAllCalculos();
        });
      },
      getAllCalculos() {
        this.loadingItems = true;

        SaneamentoVocService.getAllCalculos(this.processamentosExpirados)
          .then((response) => {
            this.calculos = [];

            response.data.calculos.forEach((element) => {
              this.calculos.push({
                id: element.id,
                nome: element.nome,
                usuario: element.usuario.nome,
                usuario_id: element.usuario.id,
                status: element.status,
                executed: element.data_processamento ? dayjs(element.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                parametros: JSON.parse(element.parametros),
                filtros: JSON.parse(element.filtros)
              });
            });
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar cálculos.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            ((this.loadingItems = false), this.iniciarTourPagina());
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        let arrTourFormatted = this.calculos.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>

<style>

</style>
